// src/apps/secret/routes/file.ts
//
// secrets-files fork: routes for E2E-encrypted file sharing.

import FileShareView from '@/apps/secret/views/FileShareView.vue'
import FileReceiveView from '@/apps/secret/views/FileReceiveView.vue'
import TransactionalLayout from '@/shared/layouts/TransactionalLayout.vue'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

const validateFileIdentifier = (id: string | string[]): id is string =>
  typeof id === 'string' && /^[a-zA-Z0-9_-]+$/.test(id)

// El logo/marca lo aporta BrandedHero en el contenido (igual que la home en
// dominios custom), así que NUNCA mostramos el MastHead superior — evita el
// doble logo. Sí mostramos el pie (tema/idioma + "Powered by"). Estático e
// incondicional para no depender del timing de domain_strategy en el store.
const fileMeta = {
  requiresAuth: false,
  layout: TransactionalLayout,
  layoutProps: {
    displayMasthead: false,
    displayNavigation: false,
    displayFooterLinks: false,
    displayFeedback: false,
    displayVersion: false,
    displayToggles: true,
    displayPoweredBy: true,
  },
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/file',
    name: 'FileShare',
    component: FileShareView,
    meta: {
      ...fileMeta,
      title: 'Share encrypted file',
    },
  },
  {
    path: '/file/:fileIdentifier',
    name: 'FileReceive',
    component: FileReceiveView,
    meta: {
      ...fileMeta,
      title: 'Receive encrypted file',
    },
    beforeEnter: (to: RouteLocationNormalized) => {
      if (!validateFileIdentifier(to.params.fileIdentifier)) {
        return { name: 'NotFound' }
      }
    },
    props: (route: RouteLocationNormalized) => ({
      fileIdentifier: route.params.fileIdentifier as string,
    }),
  },
]

export default routes
